<!-- Desktop HTML -->
<div *ngIf='screenWidth >= 1230'>
  <!-- <div class="visible-lg bmw-lg-tech-doc" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-lg-tech-doc" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class='flex-200-px'>
        <div class="bmw-lg-tech-doc-sidebar">
          <div class="bmw-tech-doc-sidebar-title">Technical Documentation</div>
          <div class="bmw-lg-tech-docs">
            <div *ngIf='!techDocs'>{{serviceError}}</div>
            <div *ngIf='techDocs'>
              <div *ngFor='let doc of techDocs'>
                <div (click)='loadDocContent(doc)' class="pointer" [ngClass]="{'mini-lg-tech-doc-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-lg-tech-doc-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-lg-tech-doc-docs' : APP_SETTINGS.isRollsRoyce === 'true'}"
                  tabindex="1">{{doc.title}}<i *ngIf='doc.isOpen' class="glyphicon glyphicon-chevron-up"></i>
                  <i *ngIf='!doc.isOpen' class="glyphicon glyphicon-chevron-down"></i></div>
                  <div *ngIf='doc.isOpen'>
                    <div class="pointer tab" [ngClass]="{'mini-lg-tech-doc-sub-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-lg-tech-doc-sub-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-lg-tech-doc-sub-docs' : APP_SETTINGS.isRollsRoyce === 'true'}"
                      tabindex="1" *ngFor='let subDoc of doc.content' (click)='loadSubDocContent(doc, subDoc)'>
                      {{subDoc.title}}.
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="bmw-lg-tech-doc-content">
          <div class="flex-container row">
            <div class="flex-30"></div>
            <div class="flex-container row space-around-center flex-40">
              <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
              <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                NEW
                <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
              </div>
              <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
            </div>
            <div class="flex-30"></div>
          </div>
          <div class="bmw-lg-tech-doc-card">
            <div class="bmw-lg-tech-doc-title flex-container row">
              <div class="flex-500-px">{{docTitle}}</div>
              <div class="flex"></div>
              <div class="flex-214-px">
                <form class="input-group" name="findDocs" style="width: 100%">
                  <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="techDoc"
                    [(ngModel)]="search4techDocs">
                  <div class="input-group-btn">
                    <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' ||APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
            <div *ngIf='techDocContentObject?.length > 0'>
              <div *ngFor='let doc of techDocContentObject'>
                <div class="bmw-lg-tech-doc-content-title">{{doc?.title}}</div>
                <div *ngFor="let subDoc of doc?.content | searchFilter: 'documentTitle': search4techDocs">
                  <a [href]="(subDoc?.documentFileName!=null && subDoc?.documentFileName?.startsWith('http')) ? subDoc?.documentFileName : 'http://'+ subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'Link'" target="_blank" (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                    <div class="bmw-lg-tech-sub-doc-content-title">
                      {{subDoc?.documentTitle}}
                      <div>
                        <i class="material-icons pointer">link</i>
                      </div>
                    </div>
                  </a>
                  <a [href]="'mount/technical_documentation/'+subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'File'" target="_blank"
                    (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                    <div class="bmw-lg-tech-sub-doc-content-title">
                      {{subDoc?.documentTitle}}
                      <div *ngIf='subDoc?.documentFileType === "pdf"'>
                        <i class="material-icons pointer">picture_as_pdf</i>
                      </div>
                      <div *ngIf='subDoc?.documentFileType === "ZIP"'>
                        <i class="material-icons pointer">file_download</i>
                      </div>
                      <div *ngIf='subDoc?.documentFileType === "xlsx"'>
                        <i class="material-icons pointer">insert_drive_file</i>
                      </div>
                      <div *ngIf='subDoc?.documentFileType === "zip" ||subDoc?.documentFileType === "exe"'>
                        <i class="material-icons pointer">file_download</i>
                      </div>
                      <div *ngIf='subDoc?.attachmentType === "Link"'>
                        <i class="material-icons pointer">link</i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth > 991 && screenWidth < 1230'>
  <!-- <div class="visible-md bmw-md-tech-doc" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-md-tech-doc" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class='flex-170-px'>
        <div class="bmw-md-tech-doc-sidebar">
          <div class="bmw-tech-doc-sidebar-title">Technical Documentation</div>
          <div class="bmw-md-tech-docs">
            <div *ngIf='!techDocs'>{{serviceError}}</div>
            <div *ngIf='techDocs'>
              <div *ngFor='let doc of techDocs' [ngClass]="{'mini-md-tech-doc-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-md-tech-doc-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-md-tech-doc-docs' : APP_SETTINGS.isRollsRoyce === 'true'}">
                <div (click)='loadDocContent(doc)' class="pointer" [ngClass]="{'mini-md-tech-doc-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-md-tech-doc-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-md-tech-doc-docs' : APP_SETTINGS.isRollsRoyce === 'true'}"
                  tabindex="1">{{doc.title}}</div>
                <div class="pointer" [ngClass]="{'mini-tech-doc-sub-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-tech-doc-sub-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-tech-doc-sub-docs' : APP_SETTINGS.isRollsRoyce === 'true'}"
                  tabindex="1" *ngFor='let subDoc of doc.content' (click)='loadSubDocContent(doc, subDoc)'>
                  {{subDoc.title}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="bmw-md-tech-doc-content">
          <div class="flex-container row">
            <div class="flex-20"></div>
            <div class="flex-container row space-around-center flex-60">
              <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
              <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                NEW
                <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
              </div>
              <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
            </div>
            <div class="flex-20"></div>
          </div>
          <div class="bmw-md-tech-doc-card">
            <div class="bmw-md-tech-doc-title flex-container row">
              <div class="flex-276-px">{{docTitle}}</div>
              <div class="flex"></div>
              <div class="flex-202-px">
                <form class="input-group" name="findDocs" style="width: 100%">
                  <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="techDoc"
                    [(ngModel)]="search4techDocs">
                  <div class="input-group-btn">
                    <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' ||APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div *ngFor='let doc of techDocContentObject'>
              <div class="bmw-md-tech-doc-content-title">{{doc?.title}}</div>
              <div *ngFor="let subDoc of doc?.content | searchFilter: 'documentTitle': search4techDocs">
                <a [href]="(subDoc?.documentFileName!=null && subDoc?.documentFileName?.startsWith('http')) ? subDoc?.documentFileName : 'http://'+ subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'Link'" target="_blank" (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                  <div class="bmw-md-tech-sub-doc-content-title">
                    {{subDoc?.documentTitle}}
                    <div>
                      <i class="material-icons pointer" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>link</i>
                    </div>
                  </div>
                </a>
                <a [href]="'mount/technical_documentation/'+subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'File'" target="_blank"
                  (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                  <div class="bmw-md-tech-sub-doc-content-title">
                    {{subDoc?.documentTitle}}
                    <div *ngIf='subDoc?.documentFileType === "pdf"'>
                      <i class="material-icons pointer" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                    </div>
                    <div *ngIf='subDoc?.documentFileType === "ZIP"'>
                      <i class="material-icons pointer" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>file_download</i>
                    </div>
                    <div *ngIf='subDoc?.documentFileType === "xlsx"'>
                      <i class="material-icons pointer" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>insert_drive_file</i>
                    </div>
                    <div *ngIf='subDoc?.attachmentType === "Link"'>
                      <i class="material-icons pointer">link</i>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Ipad HTML -->
<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <!-- <div class="visible-sm bmw-sm-tech-doc" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-sm-tech-doc" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class='flex-170-px'>
        <div class="bmw-sm-tech-doc-sidebar">
          <div class="bmw-tech-doc-sidebar-title">Technical Documentation</div>
          <div class="bmw-sm-tech-docs">
            <div *ngIf='!techDocs'>{{serviceError}}</div>
            <div *ngIf='techDocs'>
              <div *ngFor='let doc of techDocs' class="bmw-sm-tech-doc-docs">
                <div (click)='loadDocContent(doc)' class="bmw-sm-tech-doc-docs pointer" tabindex="1">{{doc.title}}</div>
                <div class="pointer" [ngClass]="{'mini-sm-tech-doc-sub-docs' : APP_SETTINGS.isMINI === 'true', 'bmw-sm-tech-doc-sub-docs': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS .isMOTORRAD === 'true') , 'rr-sm-tech-doc-sub-docs' : APP_SETTINGS.isRollsRoyce === 'true'}"
                  tabindex="1" *ngFor='let subDoc of doc.content' (click)='loadSubDocContent(doc, subDoc)'>
                  {{subDoc.title}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="bmw-sm-tech-doc-content">
          <div class="flex-container row">
            <div class="flex-20"></div>
            <div class="flex-container row flex-60 space-around-center">
              <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
              <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                NEW
                <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
              </div>
              <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
            </div>
            <div class="flex-20"></div>
          </div>
          <div class="bmw-sm-tech-doc-card">
            <div class="bmw-sm-tech-doc-title flex-container row">
              <div class="flex-276-px">{{docTitle}}</div>
              <div class="flex"></div>
              <div class="flex-202-px">
                <form class="input-group" name="findDocs" style="width: 100%">
                  <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="techDoc"
                    [(ngModel)]="search4techDocs">
                  <div class="input-group-btn">
                    <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' ||APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                      type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div *ngFor='let doc of techDocContentObject'>
              <div class="bmw-sm-tech-doc-content-title">{{doc?.title}}</div>
              <div *ngFor="let subDoc of doc?.content | searchFilter: 'documentTitle': search4techDocs">
                <a [href]="(subDoc?.documentFileName!=null && subDoc?.documentFileName?.startsWith('http')) ? subDoc?.documentFileName : 'http://'+ subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'Link'" target="_blank" (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                  <div class="bmw-sm-tech-sub-doc-content-title">
                    {{subDoc?.documentTitle}}
                    <div>
                      <i class="pointer" class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>link</i>
                    </div>
                  </div>
                </a>
                <a [href]="'mount/technical_documentation/'+subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'File'" target="_blank"
                  (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                  <div class="bmw-sm-tech-sub-doc-content-title">
                    {{subDoc?.documentTitle}}
                    <div *ngIf='subDoc?.documentFileType === "pdf"'>
                      <i class="pointer" class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                    </div>
                    <div *ngIf='subDoc?.documentFileType === "ZIP"'>
                      <i class="pointer" class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>file_download</i>
                    </div>
                    <div *ngIf='subDoc?.documentFileType === "xlsx"'>
                      <i class="pointer" class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>insert_drive_file</i>
                    </div>
                    <div *ngIf='subDoc?.attachmentType === "Link"'>
                      <i class="pointer" class="material-icons">link</i>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs bmw-xs-tech-doc" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-xs-tech-doc" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container space-around-center"  style="height: 56px">
      <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
      <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
        NEW
        <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
      </div>
      <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
    </div>
    <div class="bmw-xs-tech-doc-content">
      <div class="bmw-xs-tech-doc-title flex-container row justify-center-align-center">
        Technical Documentation
      </div>
      <div class="flex-container row justify-center-align-center">
        <form class="input-group" name="findDocs" style="width: 90%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="techDoc"
            [(ngModel)]="search4techDocs">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style':(APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngFor='let mainDoc of techDocs;let i=index'>
        <a class="bmw-xs-tech-content-doc-title flex-container row flex-align-center" [ngClass]='{"active": expandTechDoc[i]}' data-toggle="collapse"
          [href]='"#technicalDocuments" + i'>
          <div class="flex-250-px">{{mainDoc?.title}}</div>
          <div class="flex"></div>
          <i [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}' class="material-icons bmw-xs-tech-doc-toggle-expand-icon flex-30-px"
            [ngClass]='{"active": expandTechDoc[i]}' (click)='expandTechDoc[i] = !expandTechDoc[i]'>arrow_drop_down</i>
        </a>
        <div class="collapse bmw-xs-tech-doc-sub-docs" [id]='"technicalDocuments" + i'>
          <div *ngFor='let doc of mainDoc?.content'>
            <div class="bmw-xs-tech-doc-sub-doc-title">{{doc.title}}</div>
            <div  *ngFor='let subDoc of doc.content | searchFilter: "documentTitle": search4techDocs' [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22" : APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'
              class="bmw-xs-tech-doc-sub-doc-item flex-container row">
              <a href="{{subDoc?.documentFileName}}" *ngIf="subDoc?.attachmentType === 'Link'" target="_blank" (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                <div class="bmw-xs-tech-doc-sub-doc-item-title flex">{{subDoc.documentTitle}}</div>
                <a class="flex-30-px">
                  <i class="material-icons">link</i>
                </a>
              </a>
              <a [href]="'mount/technical_documentation/'+subDoc?.documentFileName" *ngIf="subDoc?.attachmentType === 'File'" target="_blank"
                (click)='saveToHistory(subDoc.id, subDoc?.documentTitle)'>
                <div class="bmw-xs-tech-doc-sub-doc-item-title flex">{{subDoc.documentTitle}}</div>
                <a class="flex-30-px">
                  <i class="material-icons">
                    {{ subDoc.documentFileType === "pdf" ? "picture_as_pdf" : subDoc.documentFileType === "zip" ? "file_download" : subDoc.documentFileType
                    === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </a>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>